import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UrlService } from 'app/core/http/url.service';
import { QuestionAttemptModel } from 'app/teacher/models/question-attempt.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class StudentQuestionAttemptService {
  public constructor(
    private readonly http: HttpClient,
    private readonly urlService: UrlService) {}

  public getQuestionAttempt(attemptId: string, itemOrder: number): Observable<QuestionAttemptModel> {
    const url = this.urlService.buildServerApiUrl('Teacher/QuestionAttempt', attemptId, itemOrder.toString());

    return this.http.get<QuestionAttemptModel>(url);
  }
}